import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { readErrorCode, readErrorMessage } from "../utils/errorHandler";
var NO_CODE_MESSAGES = {};
var EVERY_LIST_CODE_MESSAGES = {
    LISTING_QUERY_TIMEOUT: "ui-br-legaldeposits.error.list.LISTING_QUERY_TIMEOUT",
};
export var useListErrorMessage = function (error, codeMessageIds) {
    var _a;
    if (codeMessageIds === void 0) { codeMessageIds = NO_CODE_MESSAGES; }
    var formatMessage = useIntl().formatMessage;
    var _b = useState(null), serverError = _b[0], setServerError = _b[1];
    useEffect(function () {
        if (!error) {
            return undefined;
        }
        var active = true;
        Promise.all([readErrorCode(error), readErrorMessage(error)]).then(function (_a) {
            var code = _a[0], message = _a[1];
            if (active) {
                setServerError({ error: error, code: code, message: message });
            }
        });
        return function () {
            active = false;
        };
    }, [error]);
    if (!error) {
        return undefined;
    }
    var generic = formatMessage({
        id: "ui-br-legaldeposits.error.loading.data",
    });
    var current = (serverError === null || serverError === void 0 ? void 0 : serverError.error) === error ? serverError : null;
    var codeMessageId = (current === null || current === void 0 ? void 0 : current.code)
        ? ((_a = codeMessageIds[current.code]) !== null && _a !== void 0 ? _a : EVERY_LIST_CODE_MESSAGES[current.code])
        : undefined;
    var detail = codeMessageId
        ? formatMessage({ id: codeMessageId })
        : current === null || current === void 0 ? void 0 : current.message;
    return detail ? "".concat(generic, ": ").concat(detail) : generic;
};
